import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { PilotSettingsView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function PilotSettingsRoute(appWrapper : AppWrapper, request : Location) : IRoute {
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <PilotSettingsView id={+(request.params['id'] || 0)} />
            </AppWrapperView>
    };
}


// WEBPACK FOOTER //
// ./apps/pilots/pilotsettings/route.tsx